export class Reminder{
	constructor(
		public id: number = null,
		public objId: number = null,
		public rep_id: number = null,
		public fecha: any = '',
		public hora: any = '',
		public fechacontacto: any = '',
		public horacontacto: any = '',
		public descripcion: string = '',
		public type: string = '',
		public reminder: string = '',
		public email: number = 0,
		public notification: number = 0,
		public name: string = '',
		public company: string = '',
		public po: number = 0
		){}
}